/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LecturerBriefingJobParamsSlotId } from './lecturerBriefingJobParamsSlotId';
import type { LecturerBriefingJobParamsLeadTimeHours } from './lecturerBriefingJobParamsLeadTimeHours';

/**
 * Parameters for lecturer briefing job.

- slot_id: Optional slot ID to generate briefing for a specific session.
  If None, job will scan for upcoming sessions within lead_time_hours.
- lead_time_hours: Time window (in hours) to look ahead for sessions requiring briefings.
  Defaults to tenant setting if not specified.
- force_send: If True, bypass checks for whether briefing was already sent.
 */
export interface LecturerBriefingJobParams {
  slotId?: LecturerBriefingJobParamsSlotId;
  /** Override default lead time (1-168 hours). Uses tenant setting if not specified. */
  leadTimeHours?: LecturerBriefingJobParamsLeadTimeHours;
  forceSend?: boolean;
}
